import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"


export const SocialMediaAndOfficerVisit = (props) => {

    const { DataObj } = props
    const {
        Countdata,
        isCountLoading,
        PlanationDetailsCountdata,
        YearValue,
        MonthValue,
        ZoneValue,
        DashSelect,
        Language,

    } = DataObj

    const { t } = useTranslation()

    const navigate = useNavigate()


    return (
        <div className="row  m-1 mt-3" >

            <div className="col-12 col-lg-12 col-xl-8 rounded_eic  bg-white pb-2 pt-3 px-3 shadow" >

                {/* Received Complaints - Social media & Officer Visit */}
                <span className="text-dark fs-5 fw-bold all_heading_fontsize">{t('EncroachmentDashboard.UploadComplaintsSocialmediaandOfficerVisit')}</span>
                <div className="row pt-3" >

                    {/* Upload Complaint */}
                    <div className="col-12 col-md-4 col-lg-4 pb-3 cursor-pointer "
                        onClick={() => navigate(`/UploadComplaintGrid?YearValue=${YearValue}&MonthValue=${MonthValue}&ZoneValue=${ZoneValue}&DashSelect=${DashSelect}`)}
                    >
                        <div className="px-3 pt-3 background_style eic_PurpleColor rounded_eic" >
                            <div className="row">
                                <div className="col-9">
                                    <h6 className=" text-dark nowrap">{t('EncroachmentDashboard.UploadedComplaint')}</h6>
                                    <h2 className="pt-2 fw-bold text-danger">{Countdata && Countdata.UploadComplaint_Yourself ? Countdata.UploadComplaint_Yourself.toFixed(0) : '0'}</h2>
                                </div>
                                <div className="col-3 d-flex align-items-center justify-content-center ">
                                    <img src="./assets/img/eic_img/Upload_Complaint.png" className="img_opacity eic_all_card_img_size" alt="img not found" srcset="" />
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* Forward Complaints */}
                    <div className="col-12 col-md-4 pb-3 cursor-pointer"
                        onClick={() => navigate(`/ForwardComplaintsGrid?DashSelect=${DashSelect}`)}
                    >
                        <div className="px-3 pt-3 background_style eic_BlueColor rounded_eic" >
                            <div className="row">
                                <div className="col-9">
                                    <h6 className=" text-dark nowrap">{t('EncroachmentDashboard.ForwardComplaint')}</h6>
                                    <h2 className="pt-2 fw-bold text-danger">{Countdata && Countdata.ForwardComplaint_Yourself ? Countdata.ForwardComplaint_Yourself.toFixed(0) : '0'}</h2>
                                </div>
                                <div className="col-3 d-flex align-items-center justify-content-center ">
                                    <img src="./assets/img/eic_img/Forward_Complaints.png" className="img_opacity eic_all_card_img_size" alt="" srcset="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Closed Complaint */}
                    <div className="col-12 col-md-4 pb-3 cursor-pointer"
                        onClick={() => navigate(`/ClosedComplaintEnchrochmentGrid?YearValue=${YearValue}&MonthValue=${MonthValue}&ZoneValue=${ZoneValue}&DashSelect=${DashSelect}`)}
                    >
                        <div className="px-4 pt-3 background_style eic_pinkcolor rounded_eic">
                            <div className="row">
                                <div className="col-9 pt-1">
                                    <h6 className=" text-dark nowrap">{t('EncroachmentDashboard.ClosedComplaint')}</h6>
                                    <h2 className="pt-2 pt-lg-2 fw-bold text-danger ">{Countdata && Countdata.CloseComplaint_Yourself ? Countdata.CloseComplaint_Yourself.toFixed(0) : '0'}</h2>
                                </div>
                                <div className="col-3 d-flex align-items-center justify-content-center ">
                                    <img src="./assets/img/eic_img/Self_Assigned.png" className="img_opacity eic_all_card_img_size" alt="img not found" srcset="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="col-12 col-lg-12 col-xl-4 pt-3 pt-lg-3 pt-xl-0 ps-0 ps-xl-3 ">
                <div className="row border rounded_eic ms-1 bg-white pt-3 " style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>
                 
                    <div className="col-12 col-lg-10 mx-auto text-center cursor-pointer "
                        onClick={() => navigate(`/SelfAttendanceGrid?YearValue=${YearValue}&MonthValue=${MonthValue}&ZoneValue=${ZoneValue}&DashSelect=${DashSelect}`)}
                    >

                        <button type="button" className="btn  position-relative fw-bold text-danger ">
                            {t('EncroachmentDashboard.Selfattendance')}
                            {
                                Countdata && Countdata.SelfAttendance == 0 ?
                                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                        {t('EncroachmentDashboard.Absent')}
                                   </span>

                                    :
                                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success">
                                        {t('EncroachmentDashboard.Present')}
                                    </span>

                            }
                        </button>
                    </div>


                    <div className="col-12 col-lg-12 pb-3">
                        <div className="py-2  text-center eic_background_style eic_yellowcolor" >
                            <div className="row bg_icon">
                                <div className="col-12 pt-2 pb-2">
                                    <h6 className="text-dark fs-5 fw-bold">{t('EncroachmentDashboard.EmployeeAttendance')}</h6>
                                </div>

                                <div className="col-6 border-end border-warnning cursor-pointer "
                                    onClick={() => navigate(`/PresentEmployeGrid?YearValue=${YearValue}&MonthValue=${MonthValue}&ZoneValue=${ZoneValue}&DashSelect=${DashSelect}`)}
                                >
                                    <span className="text-dark">{t('EncroachmentDashboard.Present')}</span>
                                    <h4 className="pt-2  fw-bold text-danger">{Countdata && Countdata.PresentAttendance ? Countdata.PresentAttendance.toFixed(0) : '0'}</h4>
                                </div>

                                <div className="col-6 cursor-pointer "
                                    onClick={() => navigate(`/AbsentEmployeeGrid?YearValue=${YearValue}&MonthValue=${MonthValue}&ZoneValue=${ZoneValue}&DashSelect=${DashSelect}`)}
                                >
                                    <span className="text-dark">{t('EncroachmentDashboard.Absent')}</span>
                                    <h4 className="pt-2 fw-bold text-danger">{Countdata && Countdata.AbsentAttendance ? Countdata.AbsentAttendance.toFixed(0) : '0'}</h4>
                                </div>

                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    )
}